export const MealPlanRecipeSwap = {
  bindings: {
    meal: '<',
    voomeProductId: '<',
    isProductLowFodmap: '<',
    onSwap: '&',
    onRemove: '&',
    onRevert: '&',
    onPreview: '&',
    onLearnMore: '&',
  },

  template: `
    <div class="meal-plan-recipe-row">
      <recipe-row
        recipe="($ctrl.meal.recipeId && $ctrl.meal.recipe) || $ctrl.meal.originalRecipe"
        left-overs="$ctrl.meal.leftOvers"
        cookup="$ctrl.meal.cookup"
        disabled="!$ctrl.meal.recipeId"
        on-preview="$ctrl.onPreview({ recipe: recipe })">
        <button class="btn btn-pill btn-sm theme-btn"
          type="button"
          ng-click="$ctrl.loadSwaps = true; $ctrl.showSwaps = !$ctrl.showSwaps">
          <span ng-hide="$ctrl.showSwaps">Swap</span>
          <span ng-show="$ctrl.showSwaps">Done</span>
        </button>
      </recipe-row>
    </div>
    <div class="py-4 bg-gray-100"
      ng-show="$ctrl.showSwaps"
      ng-if="$ctrl.loadSwaps">
      <p class="meal-plan-swap-instruction text-md-center mb-2">
        <b class="d-block d-md-inline">
          Looking for something different?
        </b>
        <span ng-hide="$ctrl.isSwapped">
          Swap this week's {{ $ctrl.meal.recipe.name }}
        </span>
      </p>
      <div class="meal-plan-swap-scroll">
        <meal-plan-swaps
          voome-product-id="$ctrl.voomeProductId"
          recipe="$ctrl.meal.originalRecipe || $ctrl.meal.recipe"
          selected="$ctrl.meal.recipeId && $ctrl.meal.recipe"
          on-preview="$ctrl.onPreview({ recipe: recipe })"
          on-remove="$ctrl.onRemove({ meal: $ctrl.meal })"
          on-revert="$ctrl.onRevert({ meal: $ctrl.meal })"
          on-swap="$ctrl.onSwap({
            mealPlanRecipeId: $ctrl.meal.id,
            recipeContainerId: recipeContainerId
          })">
        </meal-plan-swaps>
        <div class="text-center bg-green-light py-4 mt-3"
          ng-if="!$ctrl.isProductLowFodmap">
          <h4>Want over 1000 recipes to choose from?</h4>
          <h5 class="mb-0">
            Subscribe to Voome Nutrition today.
            <a href="/nutrition" ng-click="$ctrl.onLearnMore()">Learn more</a>
          </h5>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanRecipeSwap.js